import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Spinner, styled } from '@streem/ui-react';
import { useObservable } from '../../../hooks/rxjs';
export function LoadingScreen({ videoController }) {
    const videoLoadedYn = useVideoLoaded(videoController);
    return useMemo(() => videoLoadedYn ? null : (_jsx(Container, { children: _jsx(Spinner, { size: "40px", color: "white" }) })), [videoLoadedYn]);
}
const Container = styled.span `
    z-index: 3;
    position: absolute;
`;
// export for testing
export const useVideoLoaded = (videoController) => {
    // a user will be connected before their video starts.  So, when video is enabled,
    //   wait until it has started before removing the spinner.  When video is not enabled
    //   (the user's camera is off), remove the spinner when the user is connected, since
    //   disabled video will never start.
    const [videoStarted] = useObservable(videoController.started);
    const [videoConnected] = useObservable(videoController.connected);
    const [videoEnabled] = useObservable(videoController.enabled);
    return !!videoStarted || (!!videoConnected && !videoEnabled);
};
//# sourceMappingURL=loading_screen.js.map